import apiService from 'services/api.service'
import store from 'store'

export default {
    async getMessages(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getClaimMessage',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data) {
                    const messages = response.data.data;
                    resolve(messages);
                } else {
                    reject('empty messages!');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async setRead(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'messages/setRead',
                method: 'get',
                params: params,
                locale: lang
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async sendMessage(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/setMessage',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }


}
